import React, {useState} from "react";
import {API_BASE_URL, WEB_API_BASE} from "../../utils/apiConfig";
import ReCAPTCHA from "react-google-recaptcha";
import logo from "../../assets/Images/logo.svg";
import InputField from "../../components/elements/InputField";
import {Link} from "react-router-dom";
import Button from "../../components/elements/Button";
import Wrapper from "../../components/layout/Wrapper";


const SignUser = () => {

    const [signType, setSignType] = useState(true);

    const [step, setStep] = useState(1);

    const [phone, setPhone] = useState("");

    const [name, setName] = useState("");

    const [otp, setOtp] = useState("");

    const [error, setError] = useState("");

    const [loading, setLoading] = useState(false);

    const [captchaToken, setCaptchaToken] = useState("");


    const API_BASE = API_BASE_URL;


    const resetForm = () => {

        setStep(1);

        setOtp("");

        setError("");

        setCaptchaToken("");

    };


    const switchSignType = () => {

        setSignType(prev => !prev);

        resetForm();

    };


    const requestOtp = async () => {

        if (!phone) {

            setError("لطفاً شماره تلفن همراه را وارد کنید.");

            return;

        }


        if (!captchaToken) {

            setError("لطفاً reCAPTCHA را تکمیل کنید.");

            return;

        }


        setLoading(true);

        setError("");


        try {

            const response = await fetch(
                `${API_BASE}/web-auth/request-otp`,
                {
                    method: "POST",

                    headers: {
                        "Content-Type": "application/json"
                    },

                    body: JSON.stringify({
                        phone_number: phone,
                        captchaToken
                    }),

                    credentials: "include"
                }
            );


            const data = await response.json();


            if (!response.ok || !data.success) {

                setError(
                    data.message ||
                    "ارسال کد تایید انجام نشد."
                );

                return;

            }


            setStep(2);

        } catch (err) {

            console.error(
                "OTP request error:",
                err
            );

            setError(
                "خطایی رخ داد. لطفاً دوباره تلاش کنید."
            );

        } finally {

            setLoading(false);

        }

    };


    const handleAuth = async () => {

        if (!otp) {

            setError("لطفاً کد تایید را وارد کنید.");

            return;

        }


        setLoading(true);

        setError("");


        const endpoint = signType
            ? "/web-auth/login"
            : "/web-auth/register";


        const body = signType
            ? {
                phone_number: phone,
                otp
            }
            : {
                phone_number: phone,
                name,
                otp
            };


        try {

            const response = await fetch(
                `${API_BASE}${endpoint}`,
                {
                    method: "POST",

                    headers: {
                        "Content-Type": "application/json"
                    },

                    body: JSON.stringify(body),

                    credentials: "include"
                }
            );


            const data = await response.json();


            if (!response.ok || !data.success) {

                setError(
                    data.message ||
                    "احراز هویت انجام نشد."
                );

                return;

            }


            // The session is now stored in the
            // HttpOnly cookie.

            window.location.href = "/account/course";

        } catch (err) {

            console.error(
                "Authentication error:",
                err
            );

            setError(
                "خطایی رخ داد. لطفاً دوباره تلاش کنید."
            );

        } finally {

            setLoading(false);

        }

    };


    return (
        <>
            <div className="flex w-full min-h-[89vh] xl:min-h-[91vh] rtl p-8 justify-center items-center">

                <div className="flex flex-col w-full md:w-3/4 lg:w-2/3 xl:w-1/3 p-5 xl:p-10 border-2 border-gray-100 shadow-md rounded-2xl">

                    <Link
                        to="/"
                        className="relative flex items-center mx-auto"
                    >
                        <img
                            src={logo}
                            alt="Logo"
                            className="h-16 rounded-sm"
                        />

                        <span className="text-2xl font-bold text-light-primary">
                            کدپرو
                        </span>
                    </Link>


                    <h1 className="text-2xl font-bold mt-8 mb-1 text-gray-700">
                        {signType ? "ورود" : "ثبت نام"}
                    </h1>


                    {error && (
                        <p className="text-red-500 text-md mb-2 text-center">
                            {error}
                        </p>
                    )}


                    {step === 1 ? (

                        <>
                            {!signType && (

                                <InputField
                                    type="text"
                                    title="نام"
                                    value={name}
                                    onChange={(e) =>
                                        setName(e.target.value)
                                    }
                                />

                            )}


                            <InputField
                                type="text"
                                title="شماره تلفن همراه"
                                value={phone}
                                className="mb-5"
                                onChange={(e) =>
                                    setPhone(e.target.value)
                                }
                            />


                            <ReCAPTCHA
                                sitekey={
                                    process.env
                                        .REACT_APP_RECAPTCHA_SITE_KEY
                                }
                                onChange={(token) =>
                                    setCaptchaToken(token)
                                }
                            />


                            <Button
                                onClick={requestOtp}
                                className="mt-5"
                                disabled={loading}
                            >
                                <span>
                                    {loading
                                        ? "در حال ارسال..."
                                        : "دریافت کد تایید"
                                    }
                                </span>
                            </Button>
                        </>

                    ) : (

                        <>

                            <InputField
                                type="text"
                                title="کد تایید"
                                value={otp}
                                onChange={(e) =>
                                    setOtp(e.target.value)
                                }
                            />


                            <Button
                                onClick={handleAuth}
                                className="mt-5"
                                disabled={loading}
                            >
                                <span>
                                    {loading
                                        ? "در حال انجام..."
                                        : signType
                                            ? "ورود"
                                            : "ثبت نام"
                                    }
                                </span>
                            </Button>


                            <button
                                type="button"
                                className="mt-4 text-gray-500"
                                onClick={() => setStep(1)}
                            >
                                تغییر شماره تلفن
                            </button>

                        </>

                    )}


                    <div className="w-full flex items-center justify-between flex-1 gap-x-3 text-lg text-gray-400 my-8">

                        <span className="h-0.5 bg-gray-300 w-full"></span>

                        <span>یا</span>

                        <span className="h-0.5 bg-gray-300 w-full"></span>

                    </div>


                    <Button
                        onClick={switchSignType}
                    >
                        <span>
                            {signType
                                ? "ثبت نام"
                                : "ورود"
                            }
                        </span>
                    </Button>

                </div>

            </div>


            <Wrapper className="flex-col">

                <div className="relative w-full mb-8 justify-center md:text-lg text-md lg:text-lg flex">

                    تمامی حقوق

                    <span className="flex items-center ml-2 mr-2 text-light-primary">

                        <span>کدپرو</span>

                        <img
                            src={logo}
                            alt="logo"
                            className="h-6 block mr-2 rounded-sm"
                        />

                    </span>

                    محفوظ می باشد &copy;

                </div>

            </Wrapper>
        </>
    );

};


export default SignUser;